import { ObservableMap } from 'owa-mobx4-adapter';
import { createStore } from 'satcheljs';
var composeStoreData = {
    defaultViewState: null,
    pendingViewState: null,
    floatingViewStates: new ObservableMap(),
    complianceConfigurations: new ObservableMap(),
    newMessageCreationInProgress: false,
};
export var getStore = createStore('compose', composeStoreData);
var composeStore = getStore();
export default composeStore;
//# sourceMappingURL=composeStore.js.map